module.exports = __webpack_public_path__ + "static/media/iic-logo.c3fb2a22.png";